import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-left-up', 'CornerLeftUp', [["path",{"d":"M10.027 5v10a4 4 0 0 0 4 4H19M10.027 5l5.028 4.78M10.027 5 5 9.78","key":"svg-0"}]]);